import { DomainCell, HitsCell, LastAuthCell, NameCell, RiskLevelCell } from './TopMetricTable/cells';
import { TableColumn } from '@silverfort/sf-components';
import { TableRow } from './types';

export const getTableColumns = (withBadgeProps: boolean): TableColumn<TableRow>[] => {
    return [
        {
            columnKey: 'name',
            title: 'Name',
            render: NameCell,
            columnClassName: `ps-4 ${withBadgeProps ? '[&]:w-[288px]' : '[&]:w-[192px]'}`
        },
        {
            columnKey: 'hits',
            title: 'Hits',
            render: HitsCell,
            columnClassName: `${withBadgeProps ? '[&]:min-w-[96px] [&]:max-w-[96px]' : '[&]:w-[140px]'}`
        },
        {
            columnKey: 'lastAuthTime',
            title: 'Last authentication',
            render: LastAuthCell,
            columnClassName: `${withBadgeProps ? '[&]:w-[160px]' : '[&]:w-[184px]'}`
        },
        {
            columnKey: 'riskLevel',
            title: 'Risk level',
            render: RiskLevelCell,
            columnClassName: `${withBadgeProps ? '[&]:w-[100px]' : '[&]:w-[100px]'}`
        },
        {
            columnKey: 'domain',
            title: 'Domain',
            render: DomainCell,
            columnClassName: `${withBadgeProps ? '[&]:w-[178px]' : '[&]:w-[206px]'}`
        }
    ];
};
